import NetworkLogic from "../Shared/NetworkLogic";
import UIManager from "../Shared/UIManager";
import { Global } from "../Shared/Global";
import Player from "../Models/Player";
import AudioManager from "../Shared/AudioManager";
import AddressManager from "../Shared/AddressManager";
import HallUI from "./HallUI";
import LoginQuickRegister from "./LoginQuickRegister";
import Utils from "../Shared/Utils";
const i18n = require('LanguageData');
import VerificationUI from "./VerificationUI";
import * as CryptoJS from "../Lib/crypto-js";
import Constant from "../Shared/Constant";
import SDKManager from "../Shared/SDKManager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class LoginUI extends cc.Component {
    @property(cc.Node)
    nodeQucikBtn: cc.Node = null

    @property(cc.Prefab)
    pfbCustomerServiceUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbRegisterUI: cc.Prefab = null

    @property(cc.Node)
    nodeItems: cc.Node = null

    @property(cc.Node)
    nodeUserName: cc.Node = null

    @property(cc.Node)
    nodeCode: cc.Node = null

    @property(cc.EditBox)
    ebUserName: cc.EditBox = null

    @property(cc.EditBox)
    ebPossword: cc.EditBox = null

    @property(cc.EditBox)
    ebCode: cc.EditBox = null

    @property(cc.Sprite)
    spCode: cc.Sprite = null

    @property(cc.Toggle)
    toggleRemember: cc.Toggle = null

    @property(cc.Prefab)
    pfbVerificationLayer: cc.Prefab = null

    private _codeId: number = 0
    private _userLoginConfig: {} = null
    private _bankNum: string = ""
    private _verifiedCodeId: number = 0
    private _verifiedCode: string = ""

    start() {
        this.nodeItems.active = false
        this.downloadUserConfig();
        this.refreshCodeImage()
        this.init()
    }

    private init() {
        this.toggleRemember.isChecked = !JSON.parse(cc.sys.localStorage.getItem('IsNotRememberUserID'))

        if (this.toggleRemember.isChecked && cc.sys.localStorage.getItem('SavedUserID')) {
            this.ebUserName.string = cc.sys.localStorage.getItem('SavedUserID')
        }
    }

    onBtnClick(event, userData) {
        if (userData === "login") {
            this.login()
        } else if (userData === "quickLogin") {//快速登录
            this.quickLogin();

        } else if (userData === "send") {

        } else if (userData === "go") {
            cc.instantiate(this.pfbRegisterUI).parent = this.node.parent
            this.node.destroy()
        } else if (userData === "code") {
            this.refreshCodeImage()
        } else if (userData === "close") {
            AudioManager.playSound("close")
            this.node.destroy()
        } else if (userData === "forget") {
            let hallUI = cc.find("Canvas/gameNode") && cc.find("Canvas/gameNode").getComponent(HallUI)
            hallUI && hallUI.openChildUI(this.pfbCustomerServiceUI)
            this.node.destroy()
        } else if (userData === "remember") {
            this.toggleRemember.isChecked = !this.toggleRemember.isChecked
        }
    }

    private login() {
        if (!this.check()) {
            return
        }

        let data = {
            "agentUrl": "",
            "code": this.ebCode.string,
            "codeId": this._codeId === 0 ? "" : this._codeId.toString(),
            "deviceFlag": "",
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
            "phone": "",
            "pwd": this.ebPossword.string,
            "sign": "",
            "userId": this.ebUserName.string,
            "bankNum": this._bankNum && CryptoJS.MD5(this._bankNum.toLocaleLowerCase() + this._verifiedCodeId) + "" || "",     // 验证付款账号
            "ipCode": this._verifiedCode,       // 验证付款账号时候的验证码
            "ipCodeId": this._verifiedCodeId,   // 验证付款账号时候的验证码id
        }

        UIManager.showLoadingUI()
        NetworkLogic.login(data, function (data) {
            UIManager.hideLoadingUI()
            Player.setPy("token", data.token)
            cc.log("===login登录AfterLogin data：", data);
            // 是否记住账号
            cc.sys.localStorage.setItem('IsNotRememberUserID', !this.toggleRemember.isChecked)
            if (this.toggleRemember.isChecked) {
                cc.sys.localStorage.setItem('SavedUserID', this.ebUserName.string)
            }
            cc.director.emit(Global.UserEvent.AfterLogin);
            this.node.destroy()
        }.bind(this), function (response) {
            if (!response) return
            // 需要安全验证
            if (response.code === "100") {
                let hallUI : HallUI = cc.find("Canvas/gameNode").getComponent("HallUI")
                let verificationUI = hallUI.openChildUI(this.pfbVerificationLayer).getComponent(VerificationUI)
                verificationUI.payType = response.data.type
                verificationUI.payNumber = response.data.bankNo
                verificationUI.callback = function (payNumber, code, codeId) {
                    this._bankNum = payNumber
                    this._verifiedCode = code
                    this._verifiedCodeId = codeId
                    this.login()
                    this._bankNum = ""
                    this._verifiedCode = ""
                    this._codeId = 0
                }.bind(this)
            }else {
                this.refreshCodeImage()
                // 登录超过限制则需要输入验证码
                this.downloadUserConfig()
            }
        }.bind(this))
    }

    quickLogin() {
        cc.log("====设备号：", Utils.getDeviceId());
        let data = {
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
            "domainId": Global.installParms.length === 2 ? Global.installParms[0] : "",
            "parentAgentCode": Global.installParms.length === 2 ? Global.installParms[1]['code'] : "",
            "currencyType" : ""
        }
        UIManager.showLoadingUI()
        NetworkLogic.visitorUserRegistered(data,function (rec) {
            UIManager.hideLoadingUI()
            cc.log("===visitorUserRegistered:", rec);
            if (rec["token"]) {
                Player.setPy("token", rec.token)
                //cc.sys.localStorage.setItem(Global.localStorageId.QuickLoginUserId, this.edUserId.string);
                cc.director.emit(Global.UserEvent.AfterLogin);
            } else {
                let currencyLanguageDto = this._userLoginConfig.currencyLanguageDto;
                
                if (!Array.isArray(currencyLanguageDto) || currencyLanguageDto.length <= 0) return;
                if (currencyLanguageDto.length === 1) {
                    this._quickRegister(rec,currencyLanguageDto);
                } else {
                    let hallUI: HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                    let childUI = hallUI.openChildUI(hallUI.pfbLoginCurrencyChoose);
                    childUI.getComponent("LoginCurrencyChoose").updateUI(rec,currencyLanguageDto);
                }
            }
            this.node.destroy()
        }.bind(this), function (rec) {
            cc.log("===获取游客账号失败:", rec);
            UIManager.showToastUI(i18n.t('login_text.quick_login_fail'), Global.ToastType.Error)
        });
    }


    _quickRegister(rec,currencyLanguageDto){
        return new Promise(resolve => {
            let data = {
                "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
                "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
                "domainId": Global.installParms.length === 2 ? Global.installParms[0] : "",
                "parentAgentCode": Global.installParms.length === 2 ? Global.installParms[1]['code'] : "",
                "currencyType" : currencyLanguageDto[0].currencyType
            }
            UIManager.showLoadingUI()
            NetworkLogic.visitorUserRegistered(data, function (rec) {
                UIManager.hideLoadingUI()
                cc.log("===注册成功", rec);
                if (Constant.InstallSDK === 0) {
                    SDKManager.reportRegister()
                }else if (Constant.InstallSDK === 1) {
                    SDKManager.shareInstallReportRegister()
                }
                //cc.director.emit(Global.UserEvent.AfterLogin);//登录之后
                Player.setPy("token", rec.token);
                UIManager.showVistorLoginTips()
                resolve(1)
            }.bind(this), function () {
                UIManager.hideLoadingUI()
                resolve(0)
                cc.log("===loginVisitorRegistered失败原因呢");//肯能是账号重复之类对
            }.bind(this));
        })


    }

    private refreshCodeImage() {
        this._codeId = Math.floor(Math.random() * 1000)
        let remoteUrl = AddressManager.getServerAdress() + "/api/user/generator-code?code_id=" + this._codeId.toString();
        cc.loader.load({ url: remoteUrl, type: 'png' }, function (err, texture: cc.Texture2D) {
            if (!err && this.node) {
                var spriteFrame = new cc.SpriteFrame(texture)
                this.spCode.spriteFrame = null
                this.spCode.spriteFrame = spriteFrame
            }
        }.bind(this));
    }

    private downloadUserConfig() {
        UIManager.showLoadingUI()
        NetworkLogic.userLoginConfig({},function (data) {
            UIManager.hideLoadingUI()
            cc.log("===获取登录数据：", data);
            this._userLoginConfig = data
            if (data.isOpenVisitorLogin === 0) {//0 开 1 关
                this.nodeQucikBtn.active = true;
            } else {
                this.nodeQucikBtn.active = false;
            }
            this.showItemsFromLoginConfig(data)
        }.bind(this))
    }





    private showItemsFromLoginConfig(data) {
        this.nodeItems.active = true
        this.nodeCode.active = false



        // 登录图形验证码
        if (parseInt(this._userLoginConfig["isOpenLoginCode"]) === 1) {
            this.nodeCode.active = true
        }

    }

    private check(): boolean {
        if (this.ebUserName.string.length === 0) {
            UIManager.showToastUI(i18n.t('login_text.account_pro'), Global.ToastType.Warnning)
            return false
        }

        if (this.ebPossword.string.length === 0) {
            UIManager.showToastUI(i18n.t('login_text.psw_pro'), Global.ToastType.Warnning)
            return false
        }

        // 登录图形验证码
        if (parseInt(this._userLoginConfig["isOpenLoginCode"]) === 1) {
            if (this.ebCode.string.length === 0) {
                UIManager.showToastUI(i18n.t('login_text.vfy_pro'), Global.ToastType.Warnning)
                return false
            }
        }
        return true
    }
}
